import React, {forwardRef, HTMLAttributes} from "react";
import styles from "./AppToggleContainer.module.scss";
import nlOptionsFormStyles from "../../../newsletter/NewsLetterOptionsForm.module.scss";
import selectStyles from "../../../lib/form/Select/Select.module.scss";

type AppToggleContainerProps = HTMLAttributes<HTMLDivElement> & {
  isOpening?: boolean;
  icon?: "arrow" | "filter";
};

const AppToggleContainer = forwardRef<HTMLDivElement, AppToggleContainerProps>(
  ({children, onClick, isOpening, icon}, ref) => {
    return (
      <div className={styles.item} ref={ref}>
        <div
          onClick={onClick}
          className={[
            selectStyles.wrapper,
            nlOptionsFormStyles.select,
            styles.formElementContainer,
            icon === "arrow" ? styles.customArrow : icon === "filter" ? styles.filterIcon : styles.noArrow,
            isOpening ? styles.isOpen : "",
          ].join(" ")}
        >
          <div className={styles.formElementContentContainer}>{children}</div>
        </div>
      </div>
    );
  },
);

AppToggleContainer.displayName = "AppToggleContainer";

export default AppToggleContainer;
